import React from "react";
import moment from "moment";

class EducationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      universityName: props.initialState
        ? props.initialState.universityName
        : "",
      course: props.initialState ? props.initialState.course : "",
      educationFrom: props.initialState ? props.initialState.educationFrom : "",
      educationTo: props.initialState ? props.initialState.educationTo : "",
      additionalComment: props.initialState
        ? props.initialState.additionalComment
        : "",
      refereeName: props.initialState ? props.initialState.refereeName : "",
      refereePosition: props.initialState
        ? props.initialState.refereePosition
        : ""
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.sendReference = this.sendReference.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value
    });
  }

  sendReference(event) {
    event.preventDefault();
    const data = {
      reference: {
        ...this.state,
        referenceType: "education",
        referenceDate: moment().format("DD/MM/YYYY"),
        uniqueLink: this.props.token
      }
    };
    this.props.saveReference(data);
  }

  TextInput(props) {
    return (
      <div className="form-group">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          type="text"
          className="form-control"
          id={props.id}
          name={props.id}
          value={props.value}
          onChange={this.handleInputChange}
          required={props.required}
          readOnly={props.readOnly}
        />
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={this.sendReference}>
        {this.TextInput({
          id: "universityName",
          label: "Name of University*",
          value: this.state.universityName,
          required: true
        })}
        {this.TextInput({
          id: "course",
          label: "Course*",
          value: this.state.course,
          required: true
        })}
        {this.TextInput({
          id: "educationFrom",
          label: "Date Education From*",
          value: this.state.educationFrom,
          required: true
        })}
        {this.TextInput({
          id: "educationTo",
          label: "Date Education To*",
          value: this.state.educationTo,
          required: true
        })}
        <div className="form-group">
          <label htmlFor="additionalComment">Any additional comments</label>
          <textarea
            className="form-control"
            id="additionalComment"
            name="additionalComment"
            value={this.state.additionalComment}
            onChange={this.handleInputChange}
            rows={3}
            required={false}
          ></textarea>
        </div>
        {this.TextInput({
          id: "refereeName",
          label: "Name of Referee*",
          value: this.state.refereeName,
          required: true
        })}
        {this.TextInput({
          id: "refereePosition",
          label: "Position of Referee*",
          value: this.state.refereePosition,
          required: true
        })}
        <div className="text-center">
          <button className="btn btn-primary" type="submit">
            Submit Reference
          </button>
        </div>
      </form>
    );
  }
}

export default EducationForm;
